import { getSessionId } from '@/lib/trackerSession'; // one tracker id, created if missing (lead ↔ visit, Founder 2026-09-27)
// Client-side fire-and-forget loggers for the CTA copy-variant A/B engine.
// See app/api/cta/track/route.ts (writes he_cta_events) and lib/ctaVariants.ts (picking).
function post(variantId: number, eventType: 'impression' | 'click', articleId?: number) {
  try {
    let trackerSessionId: string | null = null;
    try { trackerSessionId = getSessionId(); } catch {}
    fetch('/api/cta/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        variantId, eventType, trackerSessionId, articleId,
        // 2026-07-29 bug fix: raw location.pathname is percent-encoded for Hebrew slugs
        // (each character → 6 ASCII chars, e.g. "שמאי" → "%D7%A9%D7%9E..."), pushing
        // ordinary article paths past he_cta_events.page's varchar(255) and 500ing this
        // endpoint on every impression/click. Decode back to the real ~50-char path.
        page: typeof location !== 'undefined' ? decodeURIComponent(location.pathname) : null,
      }),
    }).catch(() => {});
  } catch {}
}

export const logCtaImpression = (variantId: number, articleId?: number) => post(variantId, 'impression', articleId);
export const logCtaClick = (variantId: number, articleId?: number) => post(variantId, 'click', articleId);
